var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyRemove = function SvgCompanyRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.334 2.083a.625.625 0 0 1 .625.625v3.541h-1.25V3.333h-8.75v10h10v1.25h-12.5v-1.25h1.25V2.708a.625.625 0 0 1 .624-.625zm-5.625 9.375H5.834v-1.25h1.875zm8.284-2.377v1.323H10.7V9.081zm-8.284-.123H5.834v-1.25h1.875zm0-2.5H5.834v-1.25h1.875z"
  })));
};
export default SvgCompanyRemove;